import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/joris_broll.jpg'
import _imports_1 from '@/assets/technologies/vue-logo.png'
import _imports_2 from '@/assets/technologies/typescript-logo.png'
import _imports_3 from '@/assets/technologies/strapi-logo.png'
import _imports_4 from '@/assets/technologies/graphql-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-3989351e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-8 px-12 pb-12 lg:pb-16 bg-stripes text-center" }
const _hoisted_2 = { class: "text-right mb-4" }
const _hoisted_3 = { class: "inline-flex flex-wrap flex-col lg:flex-row justify-center items-center gap-x-16 gap-y-6 px-10 py-8 lg:p-10 rounded-lg bg-neutral-700/75 drop-shadow-xl" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mx-auto w-48 md:w-52 rounded-full drop-shadow-lg",
    src: _imports_0,
    alt: "Joris BROLL"
  })
], -1))
const _hoisted_5 = { class: "text-center justify-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl lg:text-3xl text-[#4b89a6] mb-1" }, "Joris BROLL", -1))
const _hoisted_7 = { class: "mb-10 text-neutral-400" }
const _hoisted_8 = { class: "text-sm mb-10 max-w-md mx-auto" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap justify-center gap-4 md:gap-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-white rounded-full h-9 px-3" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "drop-shadow-lg h-full",
      src: _imports_1,
      alt: "Vue JS"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "h-9" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "rounded-full drop-shadow-lg h-full",
      src: _imports_2,
      alt: "Typescript"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "h-9" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "rounded-full drop-shadow-lg h-full",
      src: _imports_3,
      alt: "Strapi"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "h-9" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "bg-white rounded-full drop-shadow-lg h-full p-1",
      src: _imports_4,
      alt: "GraphQL"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocaleSwitch = _resolveComponent("LocaleSwitch")!
  const _component_JbMainContainer = _resolveComponent("JbMainContainer")!

  return (_openBlock(), _createBlock(_component_JbMainContainer, {
    p: "0",
    bg: "bg-neutral-900"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_LocaleSwitch)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('title')), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('small_intro_engineer')), 1),
              _hoisted_9
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}